import React from "react";
import { cn } from "../../lib/utils"; 

export const Input = ({ className, ...props }) => {
  return (
    <input
      className={cn(
        "w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-1",
        "border-gray-300 font-poppins text-base focus:border-emerald-500 focus:ring-emerald-500",
        className
      )}
      {...props}
    />
  );
};
